import {useMutation} from '@apollo/react-hooks';

import type {
    UpdateEmailSequenceTemplate as UpdateEmailSequenceTemplateMutation,
    UpdateEmailSequenceTemplateVariables as UpdateEmailSequenceTemplateMutationVariables,
    EmailSequenceTemplateUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_EMAIL_SEQUENCE_TEMPLATE from '../mutations/update-email-sequence-template.graphql';

export function useUpdateEmailSequenceTemplate(): {
    updateEmailSequenceTemplate: (input: EmailSequenceTemplateUpdateInput) => Promise<any>;
    isUpdating: boolean;
} {
    const [updateEmailSequenceTemplate, {loading}] = useMutation<
        UpdateEmailSequenceTemplateMutation,
        UpdateEmailSequenceTemplateMutationVariables
    >(UPDATE_EMAIL_SEQUENCE_TEMPLATE);

    return {
        updateEmailSequenceTemplate: (input: EmailSequenceTemplateUpdateInput) =>
            updateEmailSequenceTemplate({
                variables: {
                    emailSequenceTemplate: {
                        emailSequenceTemplate: {
                            id: input.emailSequenceTemplate.id,
                            name: input.emailSequenceTemplate.name,
                            groupId: input.emailSequenceTemplate.groupId,
                        },
                    },
                },
            }),
        isUpdating: loading,
    };
}
